import React from 'react';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export default function AssignActivityIcon(props: { onClick?: (() => void) | undefined; disabled?: boolean }) {
  const { onClick, disabled } = props;
  const color = disabled ? 'disabled' : 'primary';
  const cursor = disabled ? 'default' : (onClick ? 'pointer' : 'default');
  const handleClick = disabled ? undefined : onClick;
  return (
    <PersonAddAltIcon color={color as any} style={{ fontSize: 20, cursor }} onClick={handleClick} />
  );
}
